<template>
  <div>
    <!-- <Navbar /> -->
    <section>
      <div>
        <router-view></router-view>
      </div>
    </section>
    <!-- <Footer /> -->
  </div>

</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    this.$store.commit('onStart');
  }
};
</script>
